var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { attrs: { justify: "center" } },
    [
      _c(
        "v-col",
        { staticClass: "text-center", attrs: { cols: "12", sm: "4" } },
        [
          _c("v-icon", { attrs: { large: "", color: "primaryMedium" } }, [
            _vm._v("mdi-bookmark-multiple-outline"),
          ]),
          _vm._v(" "),
          _c("h3", { staticClass: "text-h6 font-weight-medium mt-2" }, [
            _vm._v("No notes or bookmarks found here"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-body-1 text--secondary mt-2" }, [
            _vm._v(
              "\n            Try clearing your filters. Or try bookmarking sections and adding notes to get started.\n        "
            ),
          ]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "mt-2",
              attrs: {
                outlined: "",
                color: "primary",
                href: "https://support.iccsafe.org/ht_kb/digital-codes/how-to-create-notes/",
                target: "_blank",
              },
            },
            [_vm._v("Learn About Notes")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }